import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith } from 'helpers/decorator';
import { IdealLanding } from './IdealLanding';
import { startPollingForSubscription, watchIdealLandingSagas } from './IdealLanding.saga';
export var mapDispatchToProps = {
  startPollingForSubscription: startPollingForSubscription
};
export var IdealLandingContainer = decorateWith(withSagas({
  watch: watchIdealLandingSagas
}), connect(null, mapDispatchToProps), injectIntl)(IdealLanding);